(function() { module.exports = this["sc5"]; }());